// Main entry point for the game
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './components.jsx';

// Render the app using React 18's createRoot API
document.addEventListener('DOMContentLoaded', () => {
    const rootElement = document.getElementById('app');
    const root = createRoot(rootElement);
    root.render(<App />);
});
